export default __webpack_public_path__ + "static/media/image-cover.725ef871.jpg";